import { AxiosResponse } from "axios";

import client from "../client";
import { postSignUpAppleConfig } from "./postSignUpAppleConfig";
import { PostSignUpApplePayload } from "./types";
import { PostRegisterResponseData } from "../postRegister/types";

const postSignUpApple = async (
  data?: PostSignUpApplePayload
): Promise<AxiosResponse<PostRegisterResponseData>> =>
  await client({ ...postSignUpAppleConfig, data: { provider: "apple", ...data } });

export default { postSignUpApple };
